import { get } from 'svelte/store';
import { devices_status, devices_settings } from 'src/stores/device-runtime/status';
import { conditionInterpretator } from 'src/components/Scenes/helpers/scene_conditions_to_ui';
import { actionInterpretator } from 'src/components/Scenes/helpers/scene_actions_to_ui';
import {
	getDelayedSceneAction,
	getSceneActionPurpose,
} from 'src/components/Scenes/helpers/get_delayed_scene_action';
import { real_id } from 'src/helpers/interface_helpers';

/**Select device in room with id - exclude categories, with or without shared, local or cloud or both */

type SelectDeviceByRoomType = {
	title: string;
	value: unknown;
	position: number;
	id?: string | number;
	image?: string;
	icon?: string;
	name?: string;
	roomID?: string | number;
	selected?: boolean;
	category?: string;
	backgroundColor?: string;
};
export function selectDevicesByRoom(
	_devices,
	selectedRoom,
	exclude_categories: string[] = [],
	exclude_types: string[] = [],
	exclude_shared = true,
	only_cloud_connected = true,
	include_types: string[] = [], //explicitly included device types, bypass exclusion
) {
	const settings = get(devices_settings);
	const status = get(devices_status);

	let arr: SelectDeviceByRoomType[] | [] = [];

	arr = Object.values(_devices).reduce((acc: SelectDeviceByRoomType[], curr: any) => {
		// Allow devices even if status isn't loaded yet (status may be loading asynchronously)
		// The device existing in the devices store is sufficient for selection
		const deviceExists = curr && curr.id;

		if (Number(curr.room_id) === Number(selectedRoom.value) && deviceExists) {
			if (exclude_shared && curr.shared) {
				return acc;
			}
			if (
				exclude_categories.length > 0 &&
				exclude_categories.includes(curr.category) &&
				!include_types.includes(curr.type)
			) {
				return acc;
			}
			if (exclude_types.length > 0 && exclude_types.includes(curr.type)) {
				return acc;
			}
			if (only_cloud_connected && settings[real_id(curr.id)]?.cloud?.enabled) {
				acc.push({
					title: curr.name,
					value: curr.id,
					position: curr.position,
					id: curr.id,
					image: curr.image,
					name: curr.name,
					selected: false,
					category: curr?.category,
					backgroundColor: curr?.backgroundColor,
					...(curr?.icon && { icon: curr.icon }), //Virtual Devices have Icon
				});
			} else {
				acc.push({
					title: curr.name,
					value: curr.id,
					position: curr.position,
					id: curr.id,
					image: curr.image,
					name: curr.name,
					selected: false,
					category: curr?.category,
					backgroundColor: curr?.backgroundColor,
					...(curr?.icon && { icon: curr.icon }), //Virtual Devices have Icon
				});
			}
		}
		return acc;
	}, []) as [];

	return arr.length > 0 ? arr : [];
}

export function addRemoveDeviceIdsFromMetaInSceneObject(
	type: 'condition' | 'action',
	element,
	scene_object,
) {
	let translated: any = {};

	if (type === 'condition') {
		let purpose = element._gui_type || element._gui_purpose || undefined;
		translated = conditionInterpretator(element, purpose);
	} else if (type === 'action') {
		const delayedAction = getDelayedSceneAction(element);
		if (delayedAction !== undefined) {
			//if there is do => it is a delay action, stupid, but in other way we miss it
			element = { ...delayedAction, delay: element.wait, units: element.units };
		}
		let purpose = getSceneActionPurpose(element, delayedAction);
		translated = actionInterpretator(purpose, element, element.msg_type);
	}

	if (translated?.hasOwnProperty('device')) {
		const dev_id = `${translated.device.id}${+translated.device.channel > 0 ? `_${translated.device.channel}` : ''}`;
		scene_object._meta[`${type === 'condition' ? 'c' : 'a'}di`] = scene_object._meta[
			`${type === 'condition' ? 'c' : 'a'}di`
		]?.filter((item) => item.toString() !== dev_id);
	}

	return scene_object;
}
